(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gaela-blog-articulo"]) return;
  try {
    
  (function () {
    var s = document.querySelector('.gbl--articulo');
    if (!s) return;

    s.addEventListener('click', function (e) {
      var b = e.target.closest('[data-voz]');
      if (!b || b === s) return;
      s.dataset.voz = b.dataset.voz;
      s.querySelectorAll('.gbl-voces [data-voz]').forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
    });

    // El índice lateral se arma con los h2 del cuerpo (en PC y «Con estudios»)
    var riel = s.querySelector('.gbl-riel__dentro');
    var piezas = [];
    s.querySelectorAll('.gbl-largo h2').forEach(function (h, i) {
      if (!h.id) h.id = 'parte-' + (i + 1);
      piezas.push([h, h.textContent.trim()]);
    });
    var prod = s.querySelector('#la-que-usamos');
    if (prod) piezas.push([prod, prod.querySelector('.gbl-producto__h').textContent]);
    if (piezas.length < 2) { s.querySelector('.gbl-riel').remove(); return; }
    var enlaces = piezas.map(function (p) {
      var a = document.createElement('a');
      a.href = '#' + p[0].id;
      a.textContent = p[1];
      riel.appendChild(a);
      return a;
    });
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        if (!en.isIntersecting) return;
        var i = piezas.findIndex(function (p) { return p[0] === en.target; });
        enlaces.forEach(function (a, j) { a.classList.toggle('es-actual', i === j); });
      });
    }, { rootMargin: '-35% 0px -55% 0px' });
    piezas.forEach(function (p) { io.observe(p[0]); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gaela-blog-indice"]) return;
  try {
    
  (function () {
    var s = document.querySelector('.gbl--indice');
    if (!s) return;
    s.addEventListener('click', function (e) {
      var b = e.target.closest('.gbl-pildoras button');
      if (!b) return;
      s.querySelectorAll('.gbl-pildoras button').forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
      s.querySelectorAll('.gbl-tarjeta').forEach(function (t) {
        t.hidden = b.dataset.cat !== 'todo' && (' ' + t.dataset.cats + ' ').indexOf(' ' + b.dataset.cat + ' ') < 0;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gaela-ev-en-video"] && !Shopify.designMode) return;
  try {
    
  /* EL PLAY DE CADA REEL. Quita los controles nativos (la barra negra) y pone
     el botón. 🔴 SE REPRODUCE EN LA TARJETA (2026-10-18), ya no abre el visor:
     pedido «que solo reproduzca desde ahí, y si se reproduce uno se para el
     resto». Se le pasa el clic al propio vídeo y `enSitio()` (gaela-marco.js),
     que escucha por delegación, lo arranca con sonido y para a los demás. El
     botón se esconde mientras suena y vuelve al pausar.
     🔴 NO ARRANCA SOLO (A-047). Sin JS quedan los controles de siempre. */
  /* ⚠️ 2026-10-19: el `<video>` de cada reel llega dentro de un `<template>`
     y lo monta `reels()` (gaela-marco.js) al acercarse el carril, así que
     puede no existir todavía cuando corre esto. Se prepara lo que ya esté y,
     lo que se monte después, cuando `reels()` avisa con `gaela:reel`. */
  (function () {
    document.querySelectorAll('.gf-ev-vid video.gf-ev-reel__v').forEach(prepara);
    document.addEventListener('gaela:reel', function (ev) {
      if (ev.target.closest && ev.target.closest('.gf-ev-vid')) prepara(ev.target);
    });

    function prepara(v) {
      var c = v.closest('.gf-ev-reel__c');
      if (!c || c.querySelector('.gf-ev-vid__play')) return;
      v.controls = false;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'gf-ev-vid__play';
      b.setAttribute('aria-label', 'Reproducir el vídeo');
      c.appendChild(b);
      b.addEventListener('click', function () { v.click(); });
      v.addEventListener('play', function () { b.hidden = true; });
      v.addEventListener('pause', function () { b.hidden = false; });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gaela-ev-hero"] && !Shopify.designMode) return;
  try {
    
  /* El pop-up de compra. Tres trabajos: abrirlo, llevar la cuenta y componer
     el enlace al checkout con la cantidad elegida. */
  (function () {
    /* ══ EL CARRIL DE LA GALERÍA (2026-09-26) ═══════════════════════════════
       Estructura de femprobiotics.co: flechas + tira de miniaturas. Si este
       script no corre, se ve la primera foto fija — nunca queda una caja
       vacía, porque el activo por defecto es el primer `<div>` del carril
       (Regla 9: el estado sin JS tiene que ser correcto). */
    document.querySelectorAll('[data-gf-gal]').forEach(function (gal) {
      var tope = gal.querySelectorAll('[data-gf-slide]').length;
      if (tope < 2) return;

      /* Las fotos de atrás llegan sin `src` (ver el marcado): se ponen aquí.
         `srcset` antes que `src`, o el navegador pide primero la de `src`. */
      function pon(raiz) {
        raiz.querySelectorAll('img[data-gf-src]').forEach(function (i) {
          if (i.dataset.gfSrcset) i.srcset = i.dataset.gfSrcset;
          i.src = i.dataset.gfSrc;
          i.removeAttribute('data-gf-src');
          i.removeAttribute('data-gf-srcset');
        });
      }
      if (document.readyState === 'complete') pon(gal);
      else addEventListener('load', function () { pon(gal); });

      function ir(n) {
        n = (n + tope) % tope;
        var llega = gal.querySelector('[data-gf-slide="' + n + '"]');
        if (llega) pon(llega);
        gal.querySelectorAll('[data-gf-slide]').forEach(function (s) {
          s.classList.toggle('gf-ev-gal__act', +s.dataset.gfSlide === n);
        });
        gal.querySelectorAll('[data-gf-ir]').forEach(function (t) {
          t.setAttribute('aria-selected', String(+t.dataset.gfIr === n));
        });
        gal.querySelectorAll('.gf-ev-gal__puntos i').forEach(function (p, i) {
          p.classList.toggle('gf-ev-gal__punto--act', i === n);
        });
      }
      function actual() { var a = gal.querySelector('.gf-ev-gal__act'); return a ? +a.dataset.gfSlide : 0; }

      /* ══ DESLIZAR EN VEZ DE FLECHAS (2026-09-27, pedido del dueño) ══════════
         Sobre la tira de miniaturas y sobre la foto: deslizar a la izquierda es
         «siguiente» y a la derecha «anterior», con el dedo, arrastrando el ratón
         o con el trackpad de lado. `touch-action: pan-y` deja pasar el scroll
         vertical de la página; sólo el gesto de lado es nuestro. Un arrastre no
         cuenta como clic en la miniatura (`movido`). */
      var x0 = null, y0 = 0, movido = false;
      gal.addEventListener('pointerdown', function (ev) {
        if (!ev.target.closest('.gf-ev-gal__tira, .gf-ev-gal__principal') || ev.target.closest('[data-gf-prev], [data-gf-next]')) return;
        x0 = ev.clientX; y0 = ev.clientY; movido = false;
      });
      gal.addEventListener('pointerup', function (ev) {
        if (x0 === null) return;
        var dx = ev.clientX - x0, dy = ev.clientY - y0;
        x0 = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) { movido = true; ir(actual() + (dx < 0 ? 1 : -1)); }
      });
      gal.addEventListener('pointercancel', function () { x0 = null; });
      var rueda = 0, quieto = 0;
      gal.addEventListener('wheel', function (ev) {
        if (Math.abs(ev.deltaX) <= Math.abs(ev.deltaY)) return;   // la rueda normal baja la página
        ev.preventDefault();
        if (Date.now() < quieto) return;
        rueda += ev.deltaX;
        if (Math.abs(rueda) > 40) { ir(actual() + (rueda > 0 ? 1 : -1)); rueda = 0; quieto = Date.now() + 450; }
      }, { passive: false });

      /* En CAPTURA: el visor a pantalla completa escucha los clics de la foto en
         `document`; tras un deslizamiento ese clic no debe abrirlo. */
      gal.addEventListener('click', function (ev) {
        if (movido) { movido = false; ev.stopPropagation(); ev.preventDefault(); }
      }, true);
      gal.addEventListener('click', function (ev) {
        var t = ev.target.closest('[data-gf-ir]');
        if (t) { ir(+t.dataset.gfIr); return; }
        if (ev.target.closest('[data-gf-next]')) {
          var actual = gal.querySelector('.gf-ev-gal__act');
          ir((actual ? +actual.dataset.gfSlide : 0) + 1);
        } else if (ev.target.closest('[data-gf-prev]')) {
          var act2 = gal.querySelector('.gf-ev-gal__act');
          ir((act2 ? +act2.dataset.gfSlide : 0) - 1);
        }
      });
    });

    /* ══ «LO QUIERO» DIRECTO AL CHECKOUT (2026-09-26) ════════════════════════
       Va ANTES de la salida temprana de abajo, que se va si no hay pop-up en
       la página. `destino` es declaración de función: existe desde el principio.
       🔴 SIN VELO EN LA FICHA (pedido del dueño, 2026-09-26): había DOS velos
       —éste cubría la ficha, esperaba 0,24 s y saltaba, y el checkout pintaba
       otro igual—. Ahora se salta al instante y el velo lo pone SÓLO el
       checkout. `o=` sigue viajando: es lo que le dice al checkout que se
       viene de la ficha y que nazca cubierto.
       Sin JavaScript el botón es un `submit` y añade una unidad (C-10). */
    var CENTRO = { x: 0.5, y: 0.5 };
    document.addEventListener('click', function (ev) {
      var b = ev.target.closest('[data-gf-directo]');
      if (!b || ev.metaKey || ev.ctrlKey || ev.shiftKey) return;
      ev.preventDefault();
      if (b.getAttribute('aria-busy') === 'true') return;       // idempotente: un solo viaje
      b.setAttribute('aria-busy', 'true');
      location.href = destino(b, cuantos(), CENTRO);
    });

    /* ══ LAS OFERTAS DE CANTIDAD EN LA FICHA (snippets/gaela-cantidad.liquid) ══
       Si el panel las puso «En la ficha», el botón lleva la cantidad que se
       eligió aquí (el checkout ya no deja cambiarla). Los precios de las
       opciones fijas los pinta Liquid; aquí solo se repintan los que cambian
       con la cantidad (diseños C y E), con la MISMA cuenta que el checkout:
       descuento = redondeo(bruto × % / 100), en pesos enteros. El ahorro, en
       pesos: nunca en %. Sin JS se va con 1 envase (lo que viene marcado). */
    function cuantos() {
      var c = document.querySelector('[data-gf-cant]');
      if (c && c.dataset.gfModo === 'suscripcion') return 1;   // la suscripción es UN envase al mes
      return c ? Math.max(1, parseInt(c.dataset.gfN, 10) || 1) : 1;
    }
    function pesos(n) { return '$' + Math.round(n).toLocaleString('es-CO'); }
    function repinta(c) {
      var n = cuantos(), u = parseInt(c.dataset.gfUnidad, 10) || 0, dias = parseInt(c.dataset.gfDias, 10) || 0;
      var esc = (c.dataset.gfEscalera || '').split(',').filter(Boolean).map(function (e) { return e.split(':').map(Number); });
      var pct = function (q) { var p = 0; esc.forEach(function (e) { if (q >= e[0]) p = e[1]; }); return p; };
      var bruto = u * n, ahorro = Math.round(bruto * pct(n) / 100), total = bruto - ahorro;
      c.querySelectorAll('[data-gf-op]').forEach(function (b) { b.setAttribute('aria-checked', String(+b.dataset.gfOp === n)); });
      var tot = c.querySelector('[data-gf-total]'); if (tot) tot.textContent = pesos(total);
      /* el precio dentro del botón «Añadir al carrito», como FEM */
      var mensual = c.dataset.gfModo === 'suscripcion' ? parseInt(c.dataset.gfMensual, 10) : 0;
      document.querySelectorAll('[data-gf-btn-precio]').forEach(function (p) { p.textContent = mensual ? pesos(mensual) + '/mes' : pesos(total); });
      // I · DESLIZADOR: la barra sigue a la cantidad, y la marca elegida se enciende.
      var rango = c.querySelector('[data-gf-rango]');
      if (rango) { rango.value = n; rango.style.setProperty('--p', ((n - 1) / 2 * 100) + '%'); }
      c.querySelectorAll('[data-gf-marca]').forEach(function (m) { m.toggleAttribute('data-on', +m.dataset.gfMarca === n); });
      // K · GLOBO: se desliza sobre la elegida y dice cuánto se ahorra.
      var globo = c.querySelector('[data-gf-globo]');
      if (globo) {
        globo.parentElement.style.setProperty('--i', n - 1);
        globo.textContent = ahorro ? 'Ahorras ' + pesos(ahorro) : 'Para empezar';
        globo.toggleAttribute('data-vacio', !ahorro);
      }
      var ritual = c.querySelector('[data-gf-ritual]'); if (ritual) ritual.textContent = (dias * n) + ' días de ritual';
      var linea = c.querySelector('[data-gf-linea]');
      if (!linea) return;
        linea.innerHTML = '<b>' + pesos(total) + '</b>' + (ahorro ? '<s>' + pesos(bruto) + '</s><span class="gf-cant__aho">Ahorras ' + pesos(ahorro) + '</span>' : '') +
          '<span>' + (n > 1 ? pesos(total / n) + ' c/u' : '') + (n > 1 && dias ? ' · ' : '') + (dias ? (dias * n) + ' días' : '') + '</span>';
    }
    document.addEventListener('click', function (ev) {
      var c = ev.target.closest('[data-gf-cant]');
      if (!c) return;
      var op = ev.target.closest('[data-gf-op]');
      if (!op) return;
      c.dataset.gfN = op.dataset.gfOp;
      repinta(c);
    });
    // I · DESLIZADOR: arrastrar la barra es elegir la cantidad.
    document.addEventListener('input', function (ev) {
      var r = ev.target.closest('[data-gf-rango]'), c = r && r.closest('[data-gf-cant]');
      if (!c) return;
      c.dataset.gfN = r.value;
      repinta(c);
    });
    document.querySelectorAll('[data-gf-cant]').forEach(repinta);

    /* ══ LA SUSCRIPCIÓN, con el diseño que se elija en el panel (snippets/gaela-cantidad.liquid, D-243) ══
       Pago único o suscripción. En «la tarjeta que gira», con Miembro la carta se voltea y lo que asoma pasa a decir «Pago único»;
       el selector de cantidad se esconde (1 envase al mes), el botón dice «Suscribirme» con el precio
       mensual y el enlace al checkout lleva `modo=suscripcion`. Sin JS se compra como siempre. */
    function ponModo(c, modo) {
      var sus = modo === 'suscripcion';
      c.dataset.gfModo = modo;
      var past = c.querySelector('.gf-sus__pastilla'); if (past) past.dataset.modo = modo;
      c.querySelectorAll('[data-gf-modo-op]').forEach(function (b) { b.setAttribute('aria-checked', String(b.dataset.gfModoOp === modo)); });
      var carta = c.querySelector('.gf-sus__carta'); if (carta) carta.toggleAttribute('data-girada', sus);
      var asoma = c.querySelector('.gf-sus__asoma'); if (asoma) asoma.toggleAttribute('data-mes', !sus);
      var cant = c.querySelector('[data-gf-sus-cant]'); if (cant) cant.hidden = sus;
      // Lo que solo existe en un modo (los seis diseños del panel, D-243): `data-gf-solo="unico|suscripcion"`.
      c.querySelectorAll('[data-gf-solo]').forEach(function (el) { el.hidden = el.dataset.gfSolo !== modo; });
      // El carrusel: la diapositiva elegida se trae a la vista, y los puntos la siguen.
      var pista = c.querySelector('.gf-sus__pista'), diapo = pista && pista.children[sus ? 1 : 0];
      if (diapo) pista.scrollTo({ left: diapo.offsetLeft - pista.offsetLeft - 2, behavior: 'smooth' });
      c.querySelectorAll('.gf-sus__puntos i').forEach(function (p, n) { p.toggleAttribute('data-on', (n === 1) === sus); });
      document.querySelectorAll('[data-gf-directo]').forEach(function (b) {
        var t = b.querySelector('span');
        if (!t) return;
        if (!b.dataset.gfTextoUnico) b.dataset.gfTextoUnico = t.textContent;
        t.textContent = sus ? 'Suscribirme' : b.dataset.gfTextoUnico;
      });
      repinta(c);
    }
    document.addEventListener('click', function (ev) {
      var c = ev.target.closest('[data-gf-cant][data-gf-modo]');
      if (!c) return;
      var op = ev.target.closest('[data-gf-modo-op]'), gira = ev.target.closest('[data-gf-voltear]');
      if (op) ponModo(c, op.dataset.gfModoOp);
      else if (gira) ponModo(c, c.dataset.gfModo === 'suscripcion' ? 'unico' : 'suscripcion');
    });
    addEventListener('pageshow', function () {
      document.querySelectorAll('[data-gf-directo][aria-busy]').forEach(function (b) { b.removeAttribute('aria-busy'); });
    });
    despiertaCheckout();

    /* ══ DESPERTAR EL CHECKOUT (2026-09-26, pedido del dueño) ════════════════
       Vercel apaga lo que no se usa, y la primera clienta en un rato esperaba
       ~0,6 s de arranque en frío. Cuando la ficha termina de cargar se avisa al
       checkout —al back y a la página— para que ya esté encendido al pulsar.
       🔴 NO pide producto ni precio: el precio depende de lo que ella elija
       aquí. Sin cookies, sin leer la respuesta, y como mucho una vez cada 4 min. */
    function despiertaCheckout() {
      var ir = document.querySelector('[data-gf-checkout]');
      if (!ir || !window.fetch) return;
      try {
        var ultima = +sessionStorage.getItem('gaela_despierto') || 0;
        if (Date.now() - ultima < 240000) return;
        sessionStorage.setItem('gaela_despierto', String(Date.now()));
      } catch (e) {}
      var va = function () {
        ['/api/despierta', '/?despierta=1'].forEach(function (ruta) {
          fetch(new URL(ruta, ir.dataset.gfCheckout).href, { mode: 'no-cors', credentials: 'omit', cache: 'no-store' }).catch(function () {});
        });
      };
      if (document.readyState === 'complete') setTimeout(va, 1500);
      else addEventListener('load', function () { setTimeout(va, 1500); }, { once: true });
    }

    var pops = document.querySelectorAll('[data-gf-pop]');
    if (!pops.length || !window.HTMLDialogElement) return;

    /* ⚠️ El total se formatea con `Intl`, no con el `money` de Liquid: el
       precio cambia en el navegador y Liquid ya se ejecuto.

       🔴 Y LA MONEDA SE LEE DE UN `data-`, no de una variable Liquid:
       aqui dentro Liquid NO se interpola, asi que una etiqueta de salida
       llega LITERAL al navegador y revienta el bloque entero con un error
       de sintaxis. La pagina se pinta igual y el pop-up no abre.
       ⚠️ Y no se pueden escribir ni de ejemplo en un comentario: la regla
       `StaticStylesheetAndJavascriptTags` las caza aqui dentro tambien. */
    function formato(moneda) {
      try {
        /* ⚠️ LOCALE FIJO 'es-CO', no el `lang` del documento. Con `lang="es"`
           el formato es el de España y el simbolo se va DETRAS: salia
           «240.000 $» en vez de «$ 240.000». La tienda es colombiana. */
        return new Intl.NumberFormat('es-CO',
          { style: 'currency', currency: moneda || 'COP',
            currencyDisplay: 'narrowSymbol', maximumFractionDigits: 0 });
      } catch (e) {
        /* `narrowSymbol` no existe en navegadores viejos: se reintenta sin
           el, y si tampoco, se deja el precio que puso Liquid. */
        try {
          return new Intl.NumberFormat('es-CO',
            { style: 'currency', currency: moneda || 'COP', maximumFractionDigits: 0 });
        } catch (e2) { return null; }
      }
    }

    /* ══ EL ENLACE AL CHECKOUT PROPIO ═══════════════════════════════════════
       `?v=` variante · `&q=` cantidad · `&o=` de dónde estalló la luz (en
       fracciones de la pantalla) · `&fbp=`/`&fbc=` las cookies del píxel de
       Meta, para que el checkout —que vive en otro dominio— siga a la MISMA
       persona y no la cuente como otra. */
    function galleta(nombre) {
      var m = document.cookie.match(new RegExp('(?:^|; )' + nombre + '=([^;]*)'));
      return m ? decodeURIComponent(m[1]) : '';
    }
    function destino(ir, n, o) {
      var u = new URL(ir.dataset.gfCheckout);
      u.searchParams.set('v', ir.dataset.gfVariante);
      u.searchParams.set('q', String(n));
      var cs = document.querySelector('[data-gf-cant][data-gf-modo="suscripcion"]');
      if (cs) u.searchParams.set('modo', 'suscripcion');
      if (o) u.searchParams.set('o', o.x.toFixed(3) + ',' + o.y.toFixed(3));
      var fbp = galleta('_fbp'), fbc = galleta('_fbc');
      if (fbp) u.searchParams.set('fbp', fbp);
      if (fbc) u.searchParams.set('fbc', fbc);
      return u.toString();
    }

    /* 🗑️ Aquí vivían `cargaSeda()` y `sedaAlCheckout()`: la ficha bajaba la seda
       del checkout y cubría la pantalla antes de saltar (D-223). Se quitaron el
       2026-09-26 —el velo lo pone sólo el checkout—. La cinta y el velo siguen
       en `checkout/front/public/gaela-seda.js`. */

    pops.forEach(function (pop) {
      if (pop.dataset.gfListo) return;
      pop.dataset.gfListo = '1';

      var ir = pop.querySelector('[data-gf-ir]');
      var out = pop.querySelector('[data-gf-out]');
      var tot = pop.querySelector('[data-gf-total]');
      var menos = pop.querySelector('[data-gf-d="-1"]');
      var base = parseInt(pop.dataset.gfPrecio, 10);
      var fmt = formato(pop.dataset.gfMoneda);
      var n = 1;

      /* 🔴 LA MISMA ESCALERA QUE PINTA LIQUID. Sin esto, el total de arriba
         llevaba el descuento y el de abajo no: al tocar el + el precio SUBIA
         respecto a la opcion de al lado, que es peor que no ensenar nada.
         Sale del mismo ajuste, en un `data-`, y nunca se escribe aqui. */
      var escalones = (pop.dataset.gfEscalera || '').split(',')
        .map(function (p) { var kv = p.split(':'); return [parseInt(kv[0], 10), parseFloat(kv[1])]; })
        .filter(function (kv) { return !isNaN(kv[0]) && !isNaN(kv[1]); })
        .sort(function (a, b) { return a[0] - b[0]; });

      function unidad(q) {
        var pct = 0;
        escalones.forEach(function (kv) { if (q >= kv[0]) pct = kv[1]; });
        return Math.round(base * (100 - pct) / 100);
      }

      function pinta() {
        out.textContent = n;
        menos.disabled = n <= 1;
        if (fmt && !isNaN(base)) tot.textContent = fmt.format(unidad(n) * n / 100);
        /* La cantidad viaja en el enlace de carrito, que REEMPLAZA la bolsa
           y entra al checkout: mismo evento que «Finalizar compra». */
        if (ir && ir.dataset.gfCheckout) {
          /* 🔴 EL CHECKOUT PROPIO (2026-09-26). El enlace lleva a él con la
             variante y la cantidad: todo el dinero lo calcula su servidor.
             Sin JavaScript el enlace funciona igual, sin la animación. */
          ir.href = destino(ir, n);
        } else if (ir && ir.dataset.gfBase) {
          ir.href = ir.dataset.gfBase + '/' + ir.dataset.gfVariante + ':' + n +
                    '?return_to=/checkout';
          /* Se anota la cantidad que va a quedar en la bolsa. Al volver del
             checkout, el encabezado se corrige con esto SIN preguntar al
             servidor (gaela-marco.js). Es un apunte de conveniencia: si no
             está, o el navegador no deja escribirlo, no pasa nada. */
          try { localStorage.setItem('gaela_bolsa', String(n)); } catch (e) {}
        }
        pop.querySelectorAll('[data-gf-n]').forEach(function (b) {
          b.setAttribute('aria-pressed', (+b.dataset.gfN === n) ? 'true' : 'false');
        });
      }

      pop.addEventListener('click', function (ev) {
        var op = ev.target.closest('[data-gf-n]');
        if (op) { n = +op.dataset.gfN; pinta(); return; }
        var paso = ev.target.closest('[data-gf-d]');
        if (paso && !paso.disabled) {
          n = Math.max(1, Math.min(99, n + (+paso.dataset.gfD)));
          pinta();
        }
      });

      pinta();

      /* ══ «CONTINUAR» AL CHECKOUT PROPIO ══════════════════════════════
         Se salta al instante; el velo lo pone sólo el checkout (`o=`), igual
         que en «Lo quiero» (2026-09-26).

         El envase que entró en la bolsa al abrir el pop-up (el AddToCart que
         ve el píxel de la tienda) SALE de la bolsa al irse: la compra ya no
         pasa por el carrito de Shopify y no debe quedar ahí colgado.
         `keepalive`: la petición termina aunque la página ya se haya ido. */
      if (ir && ir.tagName === 'A' && ir.dataset.gfCheckout) {
        /* Al volver con «atrás» (bfcache) el botón tiene que poder usarse otra vez. */
        addEventListener('pageshow', function () { ir.removeAttribute('aria-busy'); });
        ir.addEventListener('click', function (ev) {
          if (ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.button) return;   // pestaña nueva: que siga el enlace
          ev.preventDefault();
          if (ir.getAttribute('aria-busy') === 'true') return;                // idempotente: un solo viaje
          ir.setAttribute('aria-busy', 'true');
          if (window.fetch && ir.dataset.gfVariante) {
            try {
              fetch('/cart/change.js', {
                method: 'POST', keepalive: true,
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify({ id: String(ir.dataset.gfVariante), quantity: 0 })
              }).catch(function () {});
            } catch (e) {}
          }
          location.href = destino(ir, n, CENTRO);
        });
      } else if (ir && ir.tagName === 'A' && window.fetch) {
        /* ══ SIN CHECKOUT PROPIO (el ajuste vacío): el camino de Shopify ══
           Sólo se cambia la cantidad de la línea —`/cart/change`, que no
           emite AddToCart— y se entra al checkout de Shopify. */
        ir.addEventListener('click', function (ev) {
          var id = ir.dataset.gfVariante;
          if (!id) return;                       // sin datos, que siga el enlace
          ev.preventDefault();
          ir.setAttribute('aria-busy', 'true');
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: String(id), quantity: n })
          })
            .then(function (r) {
              if (!r.ok) throw new Error('no se pudo ajustar');
              location.href = '/checkout';
            })
            .catch(function () { location.href = ir.href; });   // el camino de siempre
        });
      }

    });

    /* El boton del panel: se le quita el submit y se abre el dialogo. Si este
       script no corre, el submit hace lo de siempre — una unidad al carrito. */
    /* ══ LA INTENCIÓN SE MIDE AL ABRIR, NO AL PAGAR ══════════════════════
       Decidido con el usuario (2026-09-21). Quien pulsa «Lo quiero» ya está
       añadiendo a la bolsa: hay intención, todavía no hay pago. Si el
       AddToCart saltara en «Continuar», iría pegado al InitiateCheckout y el
       público de Meta «añadió al carrito» sería idéntico al de «inició pago»:
       no serviría para perseguir a quien se cae por el camino.

       🔴 UNA SOLA VEZ, Y CON GUARDIA. Si el envase ya está en la bolsa no se
       añade otra vez —abrir y cerrar el pop-up tres veces no puede dejar tres
       envases—: se comprueba la bolsa antes.
       ⚠️ Y no se espera a la respuesta para abrir: el pop-up abre al
       instante y el añadido viaja por detrás. */
    var anadiendo = false;
    function aLaBolsa(pop) {
      if (anadiendo || !pop || !window.fetch) return;
      var boton = pop.querySelector('[data-gf-ir]');
      var id = boton && boton.dataset.gfVariante;
      if (!id) return;
      anadiendo = true;
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          var esta = (c.items || []).some(function (l) { return String(l.id) === String(id); });
          if (esta) return null;                      // ya estaba: no se añade
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
          });
        })
        .catch(function () {})
        .then(function () { anadiendo = false; });
    }

    /* 🔴 LA BARRA PEGAJOSA YA NO ABRE ESTE POP-UP (2026-09-23). Aquí había una
       rama que atrapaba los clics en `.gf-compra__btn` y abría este diálogo;
       se quita porque desde que el pago contra entrega lo lleva Releasit, la
       barra tiene que abrir SU formulario, no el nuestro.

       ⚠️ Y era la causa de que siguiera saliendo el pop-up viejo aunque la
       barra ya estuviera enganchada a Releasit en `gaela-compra.liquid`: esta
       rama escuchaba el CLIC y llamaba a `preventDefault()`, así que el
       `submit` del formulario de la barra —donde vive el enganche— no llegaba
       a dispararse nunca. Un listener en `document` que previene por defecto
       se come lo que venga después, y no da ningún error.

       El pop-up sigue vivo para el botón de la ficha, que es quien lo abre por
       `[data-gf-abre]`; hoy ese botón está escondido por `gaela-releasit.css`,
       así que basta con volver a enseñarlo para recuperar el flujo anterior. */
    document.addEventListener('click', function (ev) {
      var b = ev.target.closest('[data-gf-abre]');
      if (!b) return;
      var pop = document.getElementById(b.dataset.gfAbre);
      if (!pop || !pop.showModal) return;
      ev.preventDefault();
      pop.showModal();
      aLaBolsa(pop);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gaela-ev-ingredientes"] && !Shopify.designMode) return;
  try {
    
  /* LOS PUNTOS Y LAS FLECHAS del carrusel. Un punto por «página» (el ancho
     visible del carril, como The Gummy); las flechas avanzan una página. El
     carril es scroll nativo: esto sólo lo mueve y marca dónde se está. */
  (function () {
    var suave = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    document.querySelectorAll('.gf-ev-ings [data-gf-carrusel]').forEach(function (c) {
      var p = c.querySelector('.gf-ev-ings__pista');
      var m = c.querySelector('.gf-ev-ings__mando');
      var pts = c.querySelector('.gf-ev-ings__puntos');
      var ant = c.querySelector('[data-gf-ant]');
      var sig = c.querySelector('[data-gf-sig]');
      if (!p || !m || !pts) return;
      /* la «página» es el ancho del contenido: la pista va de canto a canto y
         lleva el margen como relleno a los dos lados */
      function paso() {
        var cs = getComputedStyle(p);
        return p.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
      }
      function pinta() {
        var w = paso();
        var n = Math.max(1, Math.ceil((p.scrollWidth - (p.clientWidth - w) - 4) / w));
        m.hidden = n < 2;
        if (pts.children.length !== n) {
          pts.innerHTML = '';
          for (var i = 0; i < n; i++) {
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'gf-ev-ings__punto';
            b.setAttribute('aria-label', 'Página ' + (i + 1));
            b.addEventListener('click', (function (k) {
              return function () { p.scrollTo({ left: k * paso(), behavior: suave }); };
            })(i));
            pts.appendChild(b);
          }
        }
        var alFinal = p.scrollLeft + p.clientWidth >= p.scrollWidth - 2;
        var a = alFinal ? n - 1 : Math.min(n - 1, Math.round(p.scrollLeft / w));
        [].forEach.call(pts.children, function (b, i) { b.setAttribute('aria-current', String(i === a)); });
        ant.disabled = p.scrollLeft <= 2;
        sig.disabled = alFinal;
      }
      ant.addEventListener('click', function () { p.scrollBy({ left: -paso(), behavior: suave }); });
      sig.addEventListener('click', function () { p.scrollBy({ left: paso(), behavior: suave }); });
      p.addEventListener('scroll', function () { requestAnimationFrame(pinta); }, { passive: true });
      addEventListener('resize', pinta);
      pinta();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gaela-ev-tiempo"] && !Shopify.designMode) return;
  try {
    
  /* Enciende cada hito al entrar en pantalla, y lo APAGA al salir: el usuario
     pidió que los destellos salieran «cada vez que se alumbre», así que no se
     desobserva nada. Coste: un observador por sección y ninguna escucha de
     scroll — que además en escritorio no serviría, porque ahí el que hace
     scroll es `.page-wrapper` y no el documento (A-059, contrato C-12).
     El IntersectionObserver no tiene ese problema: mira el viewport. */
  (function () {
    var lineas = document.querySelectorAll('.gf-ev-linea');
    if (!lineas.length || !('IntersectionObserver' in window)) return;

    lineas.forEach(function (linea) {
      if (linea.dataset.gfVivo) return;
      linea.dataset.gfVivo = '1';

      /* 🔴 La clase se pone AQUÍ, desde JS, y no en el Liquid. Así, si este
         script no llega a correr, los hitos se quedan encendidos y legibles
         en vez de invisibles para siempre. */
      linea.classList.add('gf-ev-linea--vivo');

      var ojo = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) {
          e.target.classList.toggle('gf-ev-hito--on', e.isIntersecting);
        });
      }, { threshold: 0.4, rootMargin: '0px 0px -8% 0px' });

      linea.querySelectorAll('[data-gf-hito]').forEach(function (h) { ojo.observe(h); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
